import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { VerdictBadge } from "./VerdictBadge";
import { Sunrise, ArrowRight } from "lucide-react";

export function FactOfDayWidget() {
    const [fod, setFod] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/fact-of-day")
            .then((r) => setFod(r.data))
            .catch(() => setFod(null))
            .finally(() => setLoading(false));
    }, []);

    if (loading || !fod) return null;

    return (
        <motion.section
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="relative"
            data-testid="fact-of-day-widget"
        >
            <Link
                to={`/check/${fod.check_id}`}
                className="block group card-surface rounded-3xl overflow-hidden hover:-translate-y-1 transition-transform"
            >
                <div className="grid md:grid-cols-5">
                    <div className="md:col-span-2 relative min-h-[240px] flex items-center justify-center p-10"
                         style={{
                            background: "linear-gradient(135deg, rgba(61,44,224,0.35), rgba(124,107,255,0.1))",
                            borderRight: "1px solid rgba(255,255,255,0.08)",
                         }}>
                        <div className="relative">
                            <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-2 flex items-center gap-1.5">
                                <Sunrise className="h-3 w-3" /> Fact of the Day
                            </div>
                            <div className="font-display text-5xl md:text-6xl font-black text-accent tracking-tight">
                                {new Date().toLocaleDateString("en-US", { month: "short", day: "numeric" })}
                            </div>
                            <VerdictBadge verdict={fod.verdict} confidence={fod.confidence} size="md" />
                        </div>
                    </div>
                    <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center">
                        {fod.category && fod.category !== "General" && (
                            <div className="text-[10px] uppercase tracking-widest text-primary mb-3">
                                {fod.category}
                            </div>
                        )}
                        <h3 className="font-display text-2xl md:text-3xl text-accent leading-tight tracking-tight mb-4 line-clamp-3">
                            &ldquo;{fod.claim}&rdquo;
                        </h3>
                        <p className="text-muted-foreground text-sm leading-relaxed line-clamp-3">
                            {fod.summary}
                        </p>
                        <div className="mt-6 flex items-center gap-1 text-sm text-primary group-hover:gap-2 transition-all">
                            See full verdict & sources <ArrowRight className="h-4 w-4" />
                        </div>
                    </div>
                </div>
            </Link>
        </motion.section>
    );
}
